<template>
  <div class="vuetify-select-wrapper">
    <v-select
      v-model="selected"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :label="label"
    >
    </v-select>
    <input type="hidden" :name="name" :value="selected">
  </div>
</template>

<script>
  export default {
    props: [
      'name',
      'items',
      'label',
      'itemText',
      'itemValue',
      'defaultSelected'
    ],

    data () {
      return {
        selected: this.defaultSelected
      }
    }
  }
</script>
